import React from "react";
import Checkbox from "componentLibrary/MuiComponentWrappers/Checkbox/Checkbox";
import { FormControlLabel, Typography, makeStyles, RaiseColors } from "client/componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var FilterCheckbox = function FilterCheckbox(_ref) {
  var option = _ref.option,
    checked = _ref.checked,
    onChange = _ref.onChange;
  var classes = makeStyles(function () {
    return {
      label: {
        marginLeft: "-9px"
      }
    };
  })();
  return /*#__PURE__*/_jsx(FormControlLabel, {
    className: classes.label,
    control: /*#__PURE__*/_jsx(Checkbox, {
      color: "secondary",
      name: option.value,
      checked: checked,
      onChange: onChange
    }),
    label: /*#__PURE__*/_jsx(Typography, {
      noWrap: true,
      variant: "paragraph_medium",
      color: RaiseColors.black,
      children: option.label
    })
  });
};
export default FilterCheckbox;